import * as React from 'react';
import Styled, { css, keyframes } from 'styled-components';

// tslint:disable-next-line:import-name
import SvgIconLoading from '../../images/icons/IconLoading';
import { media } from '../../lib/StyledComponents';

const megaloads = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

interface ISpinnerProps extends React.SVGAttributes<SVGElement> {
  small?: boolean;
}

export const Spinner = Styled(({ small, ...rest }) =>
  <SvgIconLoading focusable='false' {...rest} />
)<ISpinnerProps>`
  width: ${({ small }) => small ? '27px' : '6em'};
  line-height: 0;
  animation: ${megaloads} 850ms linear infinite;

  #loading-circle-outline {
    stroke: ${({ theme: { spinner } }) => spinner.colorBackground};
  }

  #animation-outline {
    stroke: ${({ theme: { spinner } }) => spinner.colorSegment};
  }

  #loading-spinner-no-outline {
    fill: ${({ theme: { spinner } }) => spinner.colorSegment};
  }

  ${({ small }) => small && `
    height: 27px;
  `}

  ${props => css`
    ${media.small`
      width: 7em;

      ${props.small && `
        width: 27px;
      `}
    `}
  `}
`;

Spinner.displayName = 'Spinner';

export default Spinner;
